<template>
  <div class="main">
    <div class="logout" @click="logout">退出登录</div>

    <div class="dis_column content">
      <div class="title">知观工业互联网服务平台</div>
      <div class="dis_evenly" style="margin-top: 4.4vw">
        <a class="box dis_column" :style="option.length > 6 ? 'transform: scale(.8);' : ''" v-for="(item, i) in option"
          :key="i" @click.prevent="openNewTab(item.key, item.url)">
          <img class="box_img" :src="item.img" />
          <div class="box_name">{{ item.text }}</div>
        </a>

        <a class="box dis_column" v-if="showCaiwu" @click.prevent="
          openNewTab('caiwu_Window', 'https://www.jdy.com/login/')
          ">
          <img class="box_img" src="@/assets/box2.png" />
          <div class="box_name">财务管理</div>
        </a>
      </div>
    </div>

    <div class="icp">
      Copyright © 知观知策（黑龙江）数字科技有限公司
      <img src="@/assets/iii.png" style="margin-left: 1vw" />
      <a class="icp_a" target="_blank" href="https://beian.miit.gov.cn">黑ICP备2023008339号</a>
    </div>
  </div>
</template>

<script setup>
import { ElMessage, ElMessageBox } from "element-plus";
import { ref } from "vue";
import Cookies from "js-cookie";


let option = ref([]);
let charactarList = JSON.parse(localStorage.getItem("charactarList"));
option.value = charactarList
  .map((item) => {
    let obj = {};
    if (item.systemName == "mes") {
      obj["text"] = "生产管理";
      obj["img"] = require("@/assets/box1.png");
      obj["key"] = "mes_Window";
      obj["url"] = "/mes";
    } else if (item.systemName == "决策分析") {
      obj["text"] = "决策分析";
      obj["img"] = require("@/assets/box3.png");
      obj["key"] = "jcfx_Window";
      obj["url"] = "/jcfx";
    } else if (item.systemName == "数采平台") {
      obj["text"] = "数采平台";
      obj["img"] = require("@/assets/box4.png");
      obj["key"] = "shucai_Window";
      obj["url"] = "/iot";
    } else if (item.systemName == "用户管理") {
      obj["text"] = "用户管理";
      obj["img"] = require("@/assets/box5.png");
      obj["key"] = "user_Window";
      obj["url"] = "/auth";
    } else if (item.systemName == "健康农牧业大屏") {
      if (localStorage.getItem('cid') == 24) {
        obj["text"] = "知观知策大屏";
      } else {
        obj["text"] = "健康农牧业大屏";
      }
      obj["img"] = require("@/assets/box3.png");
      obj["key"] = "jknmy_Window";
      obj["url"] = "/jknmy";
    } else if (item.systemName == "智能工位终端") {
      obj["text"] = "智能工位终端";
      obj["img"] = require("@/assets/box3.png");
      obj["key"] = "rnmy_Window";
      obj["url"] = "/rnmy";
    } else if (item.systemName == "决策分析2.0") {
      obj["text"] = "决策分析2.0";
      obj["img"] = require("@/assets/box3.png");
      obj["key"] = "middleground_Window";
      obj["url"] = "/middleground";
    } else if (item.systemName == "城市产业经济大脑") {
      obj["text"] = "城市产业经济大脑";
      obj["img"] = require("@/assets/box3.png");
      obj["key"] = "cscyjjdn_Window";
      obj["url"] = "/cscyjjdn";
    }

    return obj;
  })
  .filter((item) => item.text);

//判断是否展示财务管理
let showCaiwu = ref(false);

showCaiwu.value =
  charactarList.filter((item) => {
    return item.systemName == "金蝶";
  }).length > 0;

// const cid= localStorage.getItem('cid');
// 健康农牧业  cid 4
// 润农牧业    cid 20

let list = {
  mes_Window: null,
  caiwu_Window: null,
  jcfx_Window: null,
  shucai_Window: null,
  user_Window: null,

  jknmy_Window: null,
  rnmy_Window: null,
  middleground_Window: null,
  cscyjjdn_Window: null,
};

const obj = {};
for (const key in list) {
  obj[key] = ref(list[key]);
}

const openNewTab = (key, url) => {
  if (!key || !url) {
    ElMessage.warning("敬请期待");
    return;
  }

  if (key != "caiwu_Window") {
    let { protocol, host } = location;
    url = `${protocol}//${host.split(':')[0]}${url}`;
  }
  // if(key== 'user_Window'){
  //     window.open('http://192.168.1.26:10/', '_blank');
  //     return;
  // }

  if (obj[key].value) {
    if (obj[key].value.closed) {
      obj[key].value = window.open(url, "_blank");
      return;
    }
    obj[key].value.focus();
    return;
  }

  console.log(url)
  obj[key].value = window.open(url, "_blank");
};

const logout = () => {
  ElMessageBox.confirm("确定退出登录吗?", "提示", {
    confirmButtonText: "退出",
    cancelButtonText: "取消",
    type: "warning",
  })
    .then(() => {
      localStorage.clear();
      sessionStorage.clear();
      Cookies.remove("Admin-Token");
      Cookies.remove("Admin-Expires-In");
      ElMessage({
        type: "success",
        message: "已退出登录",
      });
      setTimeout(() => {
        location.href = "/login";
      }, 300);
    })
    .catch(() => { });
};
</script>


<style scoped>
body,
html {
  margin: 0;
  padding: 0;
  cursor: default;
}

.dis_column {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.dis_between {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.dis_evenly {
  width: 100%;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}

.dis {
  display: flex;
  align-items: center;
}

.main {
  width: 100vw;
  height: 100vh;
  background: url(../assets/bg.png) no-repeat top left;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.logout {
  position: fixed;
  padding: 6px 10px;
  cursor: pointer;
  font-size: 14px;
  top: 10px;
  right: 20px;
  color: #377cdd;
}

.content {
  width: 96vw;
  padding-bottom: 14vh;
  box-sizing: border-box;
}

.title {
  font-size: 3vw;
  font-weight: 600;
  letter-spacing: 3px;
  color: transparent;
  background-image: linear-gradient(to bottom, #5cb1fb, #1b54c7);
  -webkit-background-clip: text;
  background-clip: text;
  user-select: none;
}

.box {
  /* width: 18.75vw;
        height: 19.27vw; */
  width: 15vw;
  height: 18vw;
  background-color: #fff;
  box-shadow: 0 10px 10px -10px rgba(0, 0, 0, 0.5);
  border-radius: 1vw;
  cursor: pointer;
  -webkit-transition: transform 0.2s ease-in, border-radius 0.2s ease-in;
  transition: transform 0.2s ease-in, border-radius 0.2s ease-in;
  position: relative;
  overflow: hidden;
  color: #333333;
  text-decoration: none;
}

.box:hover {
  -webkit-transform: scale(1.02) translateY(-2px);
  transform: scale(1.02) translateY(-2px);
  border-bottom-right-radius: 4vw;
  border-top-left-radius: 4vw;
}

.box:after {
  content: "";
  display: block;
  position: absolute;
  bottom: -40%;
  left: -120%;
  background: #008cff;
  width: 40%;
  height: 200%;
  opacity: 10%;
  transform: rotate(-45deg);
}

.box:hover:after {
  left: 120%;
  transition: all 600ms cubic-bezier(0.3, 1, 0.2, 1);
  -webkit-transition: all 600ms cubic-bezier(0.3, 1, 0.2, 1);
}

/* .box:before{
        content: '';
        display: block;
        background: linear-gradient(to left, rgba(255, 255, 255, 0) 50%, rgba(73, 164, 238, 0.1) 50%);
        background-size: 220% 100%;
        background-position: right bottom;
        height: 100%;
        width: 100%;
        position: absolute;
        top: 0;
        bottom:0;
        right:0;
        left: 0;
        transition: all .4s;
        -webkit-transition: all .4s;
    }
    .box:hover:before {
        background-position: left bottom;
    } */

.box_img {
  width: 60%;
  user-select: none;
}

.box_name {
  letter-spacing: 2px;
  font-size: 1.5vw;
  font-weight: 600;
  margin-top: 2vw;
  transition: all 0.1s ease-in;
  user-select: none;
}

.box:hover .box_name {
  color: #008cff;
}

.icp {
  width: 100%;
  position: absolute;
  font-size: 0.8vw;
  color: #333333;
  bottom: 3vh;
  left: 0;
  text-align: center;
  user-select: none;
  display: flex;
  align-items: center;
  justify-content: center;
}

.icp_a {
  cursor: pointer;
  color: #333333;
  text-decoration: none;
  user-select: none;
}
</style>
